import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=48a4a07e"
import script from "./PageSettings.vue?vue&type=script&lang=ts"
export * from "./PageSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a4a07e')) {
      api.createRecord('48a4a07e', component.options)
    } else {
      api.reload('48a4a07e', component.options)
    }
    module.hot.accept("./PageSettings.vue?vue&type=template&id=48a4a07e", function () {
      api.rerender('48a4a07e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/PageSettings.vue"
export default component.exports